import React from 'react'
import {useSelector} from 'react-redux'
import {create} from 'jss'
import JssProvider from 'react-jss/lib/JssProvider'
import {
    MuiThemeProvider,
    createGenerateClassName,
    jssPreset,
} from '@material-ui/core/styles'
import {getMuiTheme} from '../../../javascripts/getMaterialTheme'

export default function (props) {
    const onPlatform = useSelector((state) => state.onPlatform)
    const theme = getMuiTheme(onPlatform)

    // Create a new class name generator.
    const generateClassName = createGenerateClassName({
        productionPrefix: `item-react-app`,
    })

    const jss = create({
        ...jssPreset(),
        // We define a custom insertion point that JSS will look for injecting the styles in the DOM.
        insertionPoint:
            typeof document !== 'undefined' &&
            document.getElementById('jss-insertion-point'),
    })

    return (
        <JssProvider jss={jss} generateClassName={generateClassName}>
            <MuiThemeProvider theme={theme}>{props.children}</MuiThemeProvider>
        </JssProvider>
    )
}
